// extracted by mini-css-extract-plugin
export default {"dragLayer":"src-views-publisherStoryEditor-containers-StoryCarouselDragLayer-StoryCarouselDragLayer__dragLayer--Ja5WC"};